<template>
  <el-dialog
    title=""
    class="share-dialog-new"
    :visible="visible"
    @close="dialogClose"
  >
    <div class="card1" v-show="pageIndex === 0">
      <shareQrcode hideTitle ref="shareQrcode"></shareQrcode>
      <putCard
        @put="put"
        ref="putCard"
        showTitle
        :show="shareSurvey.status === 1"
      ></putCard>
    </div>
    <putStatus hasBtn :show="pageIndex === 1"></putStatus>
  </el-dialog>
</template>
<script>
import shareQrcode from "@/components/shareCommon/share-qrcode.vue";
import putCard from "@/components/shareCommon/put-card.vue";
import putStatus from "@/components/shareCommon/put-status.vue";
import { mapGetters } from "vuex";

import Template from "../views/template.vue";

export default {
  name: "shareDialogNew",
  data() {
    return {
      visible: false,
      pageIndex: 0,
    };
  },
  props: ["shareDialogShow"],
  watch: {
    shareDialogShow: {
      handler(val) {
        console.log("shareDialogShow", val);
        this.visible = val;
        if (val) {
          this.pageIndex = 0;
          this.show();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["shareSurvey"]),
  },
  components: { shareQrcode, putCard, putStatus },
  methods: {
    dialogClose() {
      console.log("dialogClose");
      this.pageIndex = 0;
      this.$emit("update:shareDialogShow", false);
    },
    show() {
      console.log("show", this.visible);
      this.$nextTick(() => {
        this.$refs.shareQrcode.handleShare();
        if (this.shareSurvey.status === 1) {
          this.$refs.putCard.getPutStatus();
        }
      });
    },
    put() {
      console.log("put");
      this.pageIndex = 1;
    },
  },
};
</script>


<style lang="scss">
.share-dialog-new .el-dialog {
  position: relative;
  width: 790px;
  min-height: 240px;
  .el-dialog__body {
    padding: 10px 15px 60px;
  }
  .put-status {
    padding-bottom: 0;
  }
}
.put-way-list {
  margin-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/shareDialogNew.vue